<template>
  <div class="all">
    <div class="back"></div>
    <div class="title">
      <div class="login" v-if="!$route.query.args">欢迎来到群英荟</div>
      <div class="login-tips" v-if="!$route.query.args">登录</div>
    </div>
    <div class="ins">
      <div class="mob">
        <div class="login-icon">
          <img src="../../assets/image/login-code.png" alt="" />
        </div>
        <Field
          type="digit"
          class="inp"
          v-model="mobile"
          name="mobile"
          placeholder="请输入手机号"
        />
      </div>

      <div class="mob mb">
        <div class="login-icon">
          <img v-if="!type" src="../../assets/image/login-phone.png" alt="" />
          <img v-else src="../../assets/image/job-password.png" alt="" />
        </div>
        <div>
          <Field
            :type="type ? 'password' : 'digit'"
            class="password"
            v-model="password"
            value=""
            name="password"
            :placeholder="type ? '请输入密码' : '输入验证码'"
          />
        </div>
        <template v-if="!type">
          <div class="getYzm" v-if="gets" @click="getPIN">获取验证码</div>
          <div class="getYzm getccc" v-if="!gets">重新获取({{ seconds }}s)</div>
        </template>
      </div>
      <div class="sub">
        <div class="sub-login" v-if="checked && !$route.query.args" @click="logins">
          登录
        </div>
        <div class="sub-logins" v-if="!checked">登录</div>
      </div>

      <div class="terms">
        <Checkbox
          v-model="checked"
          class="cheb"
          icon-size="20px"
          checked-color="#0286FF"
        ></Checkbox>
        <span>
          <span>我已阅读并同意</span>
          <a class="xieyi" href="#">《用户协议》</a>
          <span>和</span>
          <a class="xieyi" href="#">《隐私协议》</a>
        </span>
      </div>

      <div class="switchType">
        <div @click="switchType">
          {{ type ? "验证码登录" : "密码登录" }}
        </div>
        <router-link :to="{ path: '/retrievePassword?type=2' }" v-if="type"
          >找回密码</router-link
        >
      </div>
    </div>
  </div>
</template>
<script>
import { login, getPin, pwloginApi } from "@/api/api/user";
import { Toast, Field, Checkbox } from "vant";
import Cookie from "js-cookie";
export default {
  data() {
    return {
      mobile: null,
      password: null,
      seconds: 60,
      gets: true,
      isAgree: true,
      checked: true,
      type: true, // 是否密码登录
    };
  },
  created() {
    // this.wechat = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5fab771b89d22233&redirect_uri='+encodeURIComponent('http://qyh.cnlaunch.com')+'&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'
    if (this.$route.query.uid) {
      sessionStorage.setItem("tuid", this.$route.query.uid);
    }
    if (this.$route.query.args) document.title = "绑定手机号";

    this.init();
  },
  components: {
    Field,
    Checkbox,
  },
  methods: {
    init() {
      let loginInfo = localStorage.getItem("loginInfo");
      if (loginInfo) {
        let { mobile, password } = JSON.parse(loginInfo);
        this.mobile = mobile;
        this.password = password;
      }
    },
    async logins() {
      let { mobile, password, type } = this;
      if (!mobile && !password) return Toast("手机号码和验证码不能为空");
      if (!mobile) return Toast("手机号码不能为空");
      if (!password) return Toast("验证码不能为空");
      this.$showLoading();
      let res;
      if (type) {
        res = await pwloginApi({
          account: mobile,
          password,
        });
      } else {
        res = await login(mobile, password);
      }
      console.log('login',res);
      if (res.data.errorCode == "0") {
        if (type) localStorage.setItem("loginInfo", JSON.stringify({ mobile, password }));
        localStorage.setItem("userInfo",  JSON.stringify(res.data.data.user));

        Cookie.set("token", res.data.data.token, { expires: 0.05 });
        Cookie.set("is_working", res.data.data.user.is_working, { expires: 0.05 });
        this.$store.commit("SET_TOKEN", res.data.data.token);

        this.$hideLoading();
        Toast({
          type: "success",
          message: "登录成功",
          duration: 1000,
        });
        this.$router.replace({ path: "/home/task" });
        // if(res.data.data.tasks > 1) {
        //   setTimeout(() => {
        //     this.$router.replace({path:'/home/mytask'})
        //   }, 1000);
        // } else {
        //   setTimeout(() => {
        //     this.$router.replace({path:'/home/task'})
        //   }, 1000);
        // }
      } else if (res.data.errorCode == "10039") {
        Toast({
          type: "success",
          message: "登录成功",
          duration: 1000,
        });
        setTimeout(() => {
          this.$router.replace({
            path: "/bos/perfect",
            query: { uid: this.$route.query.uid },
          });
        }, 1000);
        this.$store.commit("SET_PHONE", this.mobile);
        sessionStorage.setItem("setphone", this.mobile);
      } else {
        this.$hideLoading();
        Toast({
          type: "fail",
          message: res.data.errorMsg,
          duration: 1000,
        });
      }
      // login(this.mobile, this.password)
      //   .then((res) => {})
      //   .catch((err) => {
      //     console.log(err);
      //     this.$hideLoading();
      //     Toast({
      //       type: "fail",
      //       message: "网络出错",
      //       duration: 1000,
      //     });
      //   });
    },

    getPIN() {
      // console.log(typeof this.mobile)
      // console.log(this.mobile)
      if (this.mobile == null) {
        Toast("请输入手机号");
        return;
      }
      if (this.mobile.length != 11) {
        Toast("手机号有误");
        return;
      }
      this.$showLoading();
      getPin(this.mobile)
        .then((res) => {
          console.log(res);
          console.log(res.data.httpCode);
          if (res.data.errorCode == 0) {
            this.$hideLoading();
            Toast({
              type: "success",
              message: "发送成功",
              duration: 1000,
            });
            this.gets = false;
            this.timer = setInterval(() => {
              this.seconds--;
              if (this.seconds === 0) {
                clearInterval(this.timer);
                this.timer = null;
                this.seconds = 60;
                this.gets = true;
              }
            }, 1000);
          } else {
            Toast({
              type: "fail",
              message: res.data.errorMsg,
              duration: 1000,
            });
          }
        })
        .finally(() => {
          this.$hideLoading();
        });
    },
    changeRads() {
      if (this.rads === true) {
        this.rads = false;
        console.log(false);
        return;
      }
      if (this.rads === false) {
        this.rads = true;
        console.log(true);
        return;
      }
    },
    switchType() {
      this.type = !this.type;
      this.password = "";
    },
  },
};
</script>

<style lang="scss">
.all {
  height: 100%;
  padding-bottom: 10px;
  .ins {
    bottom: 30px;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 199;
    padding: 0 44px;
  }
  .terms {
    z-index: 199;
    color: #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    .cheb {
      margin-right: 9px;
    }
    .xieyi {
      color: #046eff;
    }
  }
  .back {
    height: 158px;
    background-image: url("../../assets/image/pupop.png");
    background-size: 100% 100%;
  }
  .jobback {
    height: 158px;
  }
  .tab-type {
    position: absolute;
    top: 30px;
    right: 10%;
    .code-login {
      font-size: 14px;
      background: #046eff;
      color: white;
      text-align: center;
      padding: 4px 10px;
      border-radius: 24px;
    }
    .job-login {
      font-size: 14px;
      background: white;
      color: #046eff;
      text-align: center;
      padding: 4px 10px;
      border-radius: 24px;
    }
  }
  .title {
    position: absolute;
    top: 75px;
    left: 0;
    right: 0;
    margin: auto;
    height: 228px;
    .login {
      height: 42px;
      font-size: 20px;
      color: rgba(255, 255, 255, 1);
      text-align: center;
    }
    .login-tips {
      height: 42px;
      font-size: 18px;
      color: rgba(255, 255, 255, 1);
      text-align: center;
    }
    .wel {
      width: 76px;
      height: 22px;
      font-size: 16px;
      color: rgba(255, 255, 255, 1);
      line-height: 22px;
      letter-spacing: 1px;
    }
  }
  .sub {
    padding-top: 10px;
    height: 76px;
    justify-content: center;
    .whlo {
      width: 296px;
      height: 66px;
      margin: 0 auto;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 200;
    }
    .sub-login {
      margin: 0 auto;
      // width: 276px;
      height: 35px;
      background-color: #0286ff;
      border-radius: 48px;
      font-size: 15px;
      color: white;
      font-weight: 700;
      text-align: center;
      line-height: 35px;
      z-index: 299;
    }
    .sub-logins {
      color: #ccc;
      // width: 276px;
      height: 35px;
      font-size: 15px;
      font-weight: 700;
      text-align: center;
      line-height: 35px;
      z-index: 299;
    }
  }
  .mob {
    display: flex;
    padding-top: 20px;
    height: 66px;
    border-bottom: 1px solid #d8d8d8;
    align-items: center;
    .login-icon {
      width: 26px;
      height: 50px;
      line-height: 58px;
      background-color: white;
    }
    img {
      width: 18px;
      height: 22px;
    }
    .inp {
      color: black;
      font-size: 15px;
      width: 220px;
      height: 44px;
      background: rgba(255, 255, 255, 0);
    }
    .password {
      color: black;
      font-size: 15px;
      width: 168px;
      height: 44px;
      background: rgba(255, 255, 255, 0);
    }
    .getYzm {
      z-index: 499;
      width: 90px;
      margin-left: auto;
      text-align: center;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      color: #006bff;
      font-weight: 600;
      border: 1px solid #0286ff;
      border-radius: 10px;
    }
    .getccc {
      color: #ccc;
    }
  }
  .job {
    color: black !important;
    text-align: center;
  }
  .mb {
    margin-bottom: 10px;
  }
  .van-field__control {
    color: black;
  }
}
.switchType {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  color: #046eff;
  a {
    color: #046eff;
  }
}
</style>
